import React, { useState } from 'react';
import Menuorder from '../Menu/Menuorder';
import Allorder from './Allorder';
import Pay from './Pay';
import PublicProfile from './PublicProfile';
import YourProfile from './YourProfile';

const UserProfile = () => {
    const [nav, setNav] = useState('menuorder')

    return (
        <div className='mx-5'>
            <div className="row ">

                <div className="col-md-2 my-5 text-start ">


                   <div>
                   <button className='job-btn m-0 px-4 my-4' onClick={() => setNav('menuorder')}> OrderList  </button>
                    <button className='job-btn m-0 px-4 ' onClick={() => setNav('allorder')}>AllOrder   </button>
                    <button className='job-btn m-0 px-4 my-4' onClick={() => setNav('yourProfile')}> yourProfile  </button>
                    <button className='job-btn m-0 px-4' onClick={() => setNav('publicProfile')}> ProfileInfo </button> 
                    <button className='job-btn m-0 px-4 mt-4' onClick={() => setNav('pay')}> Payment </button> 
                   </div>
                </div>
                <div className="col-md-10  ">
                    <div className="">
                        {
                            nav === "allorder" && < Allorder />
                        }
                        {
                            nav === "menuorder" && < Menuorder />
                        }

                        {
                            nav === "publicProfile" && <PublicProfile />
                        }
                        {
                            nav === "yourProfile" && < YourProfile />
                        }
                        {
                            nav === "pay" && < Pay />
                        }

                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserProfile;